import {getWidth} from 'ol/extent.js';
import { get as getProjection} from 'ol/proj.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';

import { register as registerProj4} from 'ol/proj/proj4.js';
import proj4 from 'proj4';

const projection = 'EPSG:3857';
const resolutions = [];
const matrixIds = [];
const proj3857 = getProjection(projection);
const maxResolution = getWidth(proj3857.getExtent()) / 256;

for (let i = 0; i < 20; i++) {
    matrixIds[i] = i.toString();
    resolutions[i] = maxResolution / Math.pow(2, i);
}
export const globalProjection = projection;
export const globalMatrixIds=matrixIds;
export const globalResolutions=resolutions;
export const globalMaxResolution=maxResolution;
export const globalTileGrid = new WMTSTileGrid({
    origin: [-20037508, 20037508],
    resolutions: resolutions,
    matrixIds: matrixIds,
});


export const globalMapExtent = [52958.53770973636,4973761.6744339345,1206811.0649117255,6112920.3832952045];
export const startMapExtent = [405868.56127698183991015,5294702.47973809577524662,835812.8655568880494684,5540664.12393978238105774];


proj4.defs("EPSG:2154","+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");
registerProj4(proj4);

const proj2154 = getProjection('EPSG:2154');
export const projection2154 = proj2154;
export const projection3857 = proj3857;

export const urlDirectus='https://admin-carto.marseille.archi.fr/';
export const urlAPIDirectus='https://admin-carto.marseille.archi.fr/items/';
export const urlGeoserver='https://geoportail.marseille.archi.fr/geoserver/';